const PAYMENT_TYPE = {
  PREPAID_WALLET: 'prepaid_wallet',
  MONTHLY_SETTLEMENT: 'cash_credit',
}

export { PAYMENT_TYPE }
